import { render } from "./PatientsListView.vue?vue&type=template&id=2eb08da6&scoped=true"
import script from "./PatientsListView.vue?vue&type=script&lang=js"
export * from "./PatientsListView.vue?vue&type=script&lang=js"

import "./PatientsListView.vue?vue&type=style&index=0&id=2eb08da6&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb08da6"]])

export default __exports__